var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('calendar-wrapper-test',{attrs:{"display_work_mode":_vm.SINGLE_UNIT}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }